import * as React from 'react';
import { TableCell, TableRow } from '@telia-front/table';
import CategoryHeading from './category-heading';
import DataCell from './data-cell';
import NameRow from './name-row';
import Table from './table';
import { cellBEM, getItemInfoByCategoryItem, usePlaceholderArray } from './utils';
const ContentTable = (props) => {
    const { category, items, isMobile } = props;
    const placeholders = usePlaceholderArray(items.length);
    const totalItemCount = items.length + placeholders.length;
    const dataCellWidth = (isMobile ? 12 / totalItemCount : 2);
    return (React.createElement(Table, { itemCount: items.length, isMobile: isMobile },
        React.createElement("caption", null,
            React.createElement(CategoryHeading, { label: props.label })),
        React.createElement("thead", { className: "sr-only" },
            React.createElement(NameRow, { renderButton: false, items: props.items, deviceLabel: props.deviceLabel, isMobile: isMobile })),
        React.createElement("tbody", null, category.items.map((categoryItem, i) => {
            return (React.createElement(TableRow, { className: "product-comparison__table-row", key: i },
                React.createElement(TableCell, { className: cellBEM(categoryItem.isDifferent, isMobile), width: 3, type: "th", scope: "row" },
                    categoryItem.label,
                    categoryItem.labelAside && (React.createElement(React.Fragment, null,
                        "\u00A0",
                        categoryItem.labelAside))),
                items.map((item, index) => {
                    const data = getItemInfoByCategoryItem(category.id, categoryItem.id, item);
                    if (data) {
                        return React.createElement(DataCell, { key: `${data.id}-${index}`, categoryItem: categoryItem, data: data, isMobile: isMobile, width: dataCellWidth });
                    }
                    return React.createElement(DataCell, { key: `placeholder-${index}`, width: dataCellWidth });
                }),
                placeholders.map((_i, index) => {
                    return React.createElement(DataCell, { key: `placeholder-${index}`, width: dataCellWidth });
                })));
        }))));
};
export default ContentTable;
